import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../components/navbar";
import digiyatradashboardImg from "../assets/digiyatra-screens.jpg";

const SPECS = `data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='48' height='28' viewBox='0 0 48 28'%3E%3Crect x='1' y='4' width='18' height='18' rx='9' ry='9' fill='none' stroke='%231a1a1a' stroke-width='2.5'/%3E%3Crect x='29' y='4' width='18' height='18' rx='9' ry='9' fill='none' stroke='%231a1a1a' stroke-width='2.5'/%3E%3Cpath d='M19 13 L29 13' stroke='%231a1a1a' stroke-width='2.5' stroke-linecap='round'/%3E%3Cpath d='M1 13 L0 8' stroke='%231a1a1a' stroke-width='2' stroke-linecap='round'/%3E%3Cpath d='M47 13 L48 8' stroke='%231a1a1a' stroke-width='2' stroke-linecap='round'/%3E%3C/svg%3E`;

const css = `
@import url('https://fonts.googleapis.com/css2?family=DM+Sans:ital,wght@0,300;0,400;0,500;0,600;0,700;0,800;1,400&display=swap');
*,*::before,*::after{box-sizing:border-box;margin:0;padding:0;scroll-behavior:smooth}
body{
  background:#fafafa;
  background-image:linear-gradient(rgba(0,0,0,0.045) 1px,transparent 1px),linear-gradient(90deg,rgba(0,0,0,0.045) 1px,transparent 1px);
  background-size:32px 32px;
  font-family:'DM Sans',sans-serif;
  color:#111;
  cursor:url("${SPECS}") 24 14,auto;
}
a,button{cursor:url("${SPECS}") 24 14,pointer}

@keyframes fadeUp{from{opacity:0;transform:translateY(16px)}to{opacity:1;transform:translateY(0)}}
.d0{animation:fadeUp .5s .00s ease both}
.d1{animation:fadeUp .5s .10s ease both}
.d2{animation:fadeUp .5s .20s ease both}
.d3{animation:fadeUp .5s .30s ease both}
.reveal{opacity:0;transform:translateY(16px);transition:opacity .6s ease,transform .6s ease}
.reveal.in{opacity:1;transform:translateY(0)}

.back{display:inline-flex;align-items:center;gap:8px;font-size:11px;font-weight:600;letter-spacing:.1em;text-transform:uppercase;color:#aaa;background:none;border:none;padding:0;transition:color .15s}
.back:hover{color:#111}
.mlabel{font-size:11px;font-weight:500;color:#aaa;letter-spacing:.08em;display:block;margin-bottom:10px}
.lh{font-size:clamp(26px,4.5vw,44px);font-weight:800;letter-spacing:-0.03em;line-height:1.1;color:#111}
.bt{font-size:15px;color:#555;line-height:1.85}
.hl{background:#fde047;padding:0 3px;border-radius:2px}
.bq{border-left:3px solid #111;padding-left:20px;font-size:16px;font-weight:600;color:#111;line-height:1.5}
.div{border:none;border-top:1px solid #e8e8e8;margin:0}
.prog{transition:width .3s}
.ndot{width:24px;height:24px;border-radius:50%;background:#111;color:#fff;font-size:10px;font-weight:800;display:flex;align-items:center;justify-content:center;flex-shrink:0;margin-top:1px}

::-webkit-scrollbar{width:3px}
::-webkit-scrollbar-thumb{background:#ddd;border-radius:4px}

@media(max-width:900px){
  .four-col{grid-template-columns:repeat(2,1fr)!important}
  .six-col{grid-template-columns:repeat(2,1fr)!important}
}
@media(max-width:640px){
  .sc-row{flex-direction:column!important}
  .two-col{grid-template-columns:1fr!important}
  .three-col{grid-template-columns:1fr!important}
  .four-col{grid-template-columns:1fr!important}
  .six-col{grid-template-columns:1fr!important}
  main{padding:20px 16px 64px!important}
  .lh{font-size:clamp(22px,6vw,30px)!important}
}
`;

function useReveal() {
  const ref = useRef(null);
  useEffect(() => {
    const el = ref.current; if (!el) return;
    const obs = new IntersectionObserver(([e]) => {
      if (e.isIntersecting) { el.classList.add("in"); obs.disconnect(); }
    }, { threshold:.06 });
    obs.observe(el); return () => obs.disconnect();
  }, []);
  return ref;
}
function Sec({ children, style }) {
  const r = useReveal();
  return <section ref={r} className="reveal" style={{ marginBottom:88,...style }}>{children}</section>;
}
function useWidth() {
  const [w, setW] = useState(typeof window !== "undefined" ? window.innerWidth : 1200);
  useEffect(() => {
    const fn = () => setW(window.innerWidth);
    window.addEventListener("resize", fn);
    return () => window.removeEventListener("resize", fn);
  }, []);
  return w;
}

/* ── Numbered annotation list ── */
function AnnList({ items }) {
  return (
    <div style={{ display:"flex", flexDirection:"column", gap:20 }}>
      {items.map((a,i) => (
        <div key={i} style={{ display:"flex", gap:14, alignItems:"flex-start" }}>
          <div className="ndot">{i+1}</div>
          <div>
            <p style={{ fontSize:13, fontWeight:700, color:"#111", marginBottom:4 }}>{a.label}</p>
            <p style={{ fontSize:12.5, color:"#666", lineHeight:1.65 }}>{a.body}</p>
          </div>
        </div>
      ))}
    </div>
  );
}

/* ── Full-width screen with annotations below ── */
function ScreenFull({ src, alt, bg="#f5f5f5", annotations=[] }) {
  return (
    <div style={{ border:"1px solid #e8e8e8" }}>
      <div style={{ background:bg, padding:"32px 28px", display:"flex", justifyContent:"center" }}>
        <img src={src} alt={alt} style={{ width:"100%", maxWidth:900, display:"block", boxShadow:"0 8px 32px rgba(0,0,0,0.10)" }} />
      </div>
      <div style={{ background:"#fff", padding:"28px 32px", display:"grid", gridTemplateColumns:"repeat(2,1fr)", gap:24 }} className="two-col">
        {annotations.map((a,i) => (
          <div key={i} style={{ display:"flex", gap:14, alignItems:"flex-start" }}>
            <div className="ndot">{i+1}</div>
            <div>
              <p style={{ fontSize:13, fontWeight:700, color:"#111", marginBottom:4 }}>{a.label}</p>
              <p style={{ fontSize:12.5, color:"#666", lineHeight:1.65 }}>{a.body}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

/* ── IA diagram ── */
function IADiagram() {
  const modules = [
    { name:"Onboarding", items:["Face registration","Aadhaar/ID linking","Consent screen","Profile setup"] },
    { name:"Ticket Linking", items:["Flight search","PNR entry","Airline sync","Confirmation"] },
    { name:"Entry Gate", items:["Face scan","Boarding pass validation","Entry confirmation","Error recovery"] },
    { name:"Security Check", items:["Face match","ID cross-check","Status display","Proceed signal"] },
    { name:"Boarding Gate", items:["Final face scan","Boarding confirmation","Gate number display","Delay alerts"] },
    { name:"Support", items:["Help & FAQs","Report an issue","Manual verification fallback","Contact airline"] },
  ];
  return (
    <div style={{ border:"1px solid #e8e8e8", background:"#e8e8e8", display:"grid", gridTemplateColumns:"1fr", gap:1 }}>
      <div style={{ background:"#111", padding:"16px 24px" }}>
        <p style={{ fontSize:13, fontWeight:700, color:"#fff" }}>DigiYatra — Airport Travel App</p>
        <p style={{ fontSize:11, color:"#555", marginTop:2 }}>Facial recognition · Contactless · 6 checkpoint journey</p>
      </div>
      <div style={{ display:"grid", gridTemplateColumns:"repeat(3,1fr)", gap:1 }} className="three-col">
        {modules.map((m,i) => (
          <div key={i} style={{ background:"#fff", padding:"18px 20px" }}>
            <p style={{ fontSize:12, fontWeight:800, color:"#111", marginBottom:10 }}>{m.name}</p>
            {m.items.map((it,j) => (
              <p key={j} style={{ fontSize:11.5, color:"#888", lineHeight:1.7, paddingLeft:10, borderLeft:"1.5px solid #e8e8e8" }}>{it}</p>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}

/* ── Journey flow ── */
function JourneyFlow() {
  const steps = [
    { step:"Download & Register", action:"Face scan + Aadhaar linking", design:"Consent-first — explicit, plain language before biometric capture" },
    { step:"Link Flight Ticket", action:"PNR entry → airline sync", design:"One-time per journey — system remembers for the trip" },
    { step:"Airport Entry Gate", action:"Walk through — face scanned", design:"Zero interaction required — gate opens on recognition" },
    { step:"Security Check", action:"Face match + ID cross-check", design:"2 second clearance — no document presentation" },
    { step:"Boarding Gate", action:"Final face scan → board", design:"One scan resolves both identity and boarding — not two steps" },
    { step:"Confirmation", action:"Boarding confirmed on phone", design:"Push notification — not a screen the passenger has to show" },
  ];
  return (
    <div style={{ border:"1px solid #e8e8e8", background:"#e8e8e8", display:"grid", gridTemplateColumns:"1fr", gap:1 }}>
      <div style={{ background:"#fafafa", padding:"14px 20px", display:"grid", gridTemplateColumns:"1.5fr 2fr 2fr" }}>
        {["Checkpoint","What happens","Design decision"].map(h => (
          <p key={h} style={{ fontSize:10, fontWeight:700, letterSpacing:".12em", textTransform:"uppercase", color:"#aaa" }}>{h}</p>
        ))}
      </div>
      {steps.map((s,i) => (
        <div key={i} style={{ background:"#fff", padding:"16px 20px", display:"grid", gridTemplateColumns:"1.5fr 2fr 2fr", gap:12, alignItems:"center" }}>
          <div style={{ display:"flex", alignItems:"center", gap:10 }}>
            <div style={{ width:20, height:20, borderRadius:"50%", background:"#111", color:"#fff", fontSize:9, fontWeight:800, display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0 }}>{i+1}</div>
            <p style={{ fontSize:13, fontWeight:700, color:"#111" }}>{s.step}</p>
          </div>
          <p style={{ fontSize:12.5, color:"#777", lineHeight:1.5 }}>{s.action}</p>
          <p style={{ fontSize:12.5, color:"#555", lineHeight:1.5 }}>{s.design}</p>
        </div>
      ))}
    </div>
  );
}

/* ── Journey label: Register → Verify → Travel → Board → Complete ── */
function JourneyLabel() {
  const stages = ["Register", "Verify", "Travel", "Board", "Complete"];
  return (
    <div style={{ display:"flex", alignItems:"center", flexWrap:"wrap", gap:8, marginBottom:28 }}>
      {stages.map((s,i) => (
        <div key={s} style={{ display:"flex", alignItems:"center", gap:8 }}>
          <span style={{ fontSize:11, fontWeight:700, letterSpacing:".08em", textTransform:"uppercase", color:"#111", background:"#fff", border:"1px solid #e8e8e8", borderRadius:999, padding:"6px 14px" }}>{s}</span>
          {i < stages.length-1 && (
            <svg width="16" height="10" viewBox="0 0 16 10" fill="none"><path d="M1 5h13M9 1l5 4-5 4" stroke="#bbb" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg>
          )}
        </div>
      ))}
    </div>
  );
}

/* ═══ MAIN ═══ */
export default function CaseStudy3() {
  const [prog, setProg] = useState(0);
  const navigate = useNavigate();
  const w = useWidth();
  const isMobile = w < 640;

  useEffect(() => {
    const fn = () => { const el = document.documentElement; setProg((el.scrollTop/(el.scrollHeight-el.clientHeight))*100); };
    window.addEventListener("scroll",fn); return ()=>window.removeEventListener("scroll",fn);
  },[]);

  return (
    <div style={{ background:"#fafafa", minHeight:"100vh", backgroundImage:"linear-gradient(rgba(0,0,0,0.045) 1px,transparent 1px),linear-gradient(90deg,rgba(0,0,0,0.045) 1px,transparent 1px)", backgroundSize:"32px 32px" }}>
      <style>{css}</style>
      <div style={{ position:"fixed",top:0,left:0,right:0,height:3,background:"rgba(0,0,0,0.07)",zIndex:100 }}>
        <div className="prog" style={{ height:"100%",background:"#111",width:`${prog}%` }} />
      </div>

      <Navbar />

      <main style={{ padding:isMobile?"20px 16px 64px":"40px 6vw 100px" }}>

        {/* back */}
        <div className="d0" style={{ marginBottom:40 }}>
          <button className="back" onClick={()=>navigate("/")}>
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M9 2L4 7l5 5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg>
            Back
          </button>
        </div>

        {/* ══ HERO — Business Problem → My Role → Outcome ══ */}
        <section style={{ marginBottom:80 }}>
          <div className="d0" style={{ display:"flex",gap:8,flexWrap:"wrap",marginBottom:20 }}>
            {["Mobile App","B2C","Government Initiative","NDA Safe"].map(t=>(
              <span key={t} style={{ fontSize:11,fontWeight:500,color:"#888",background:"#f0f0f0",borderRadius:999,padding:"3px 12px" }}>{t}</span>
            ))}
          </div>
          <h1 className="d1 lh" style={{ marginBottom:20 }}>
            DigiYatra — Seamless Airport Travel Experience
          </h1>
          <p className="d2 bt" style={{ marginBottom:36 }}>
            Indian airports relied on repeated manual identity verification, creating <span className="hl">long queues, unnecessary friction, and inconsistent passenger experiences</span> at every checkpoint.
            I designed the end-to-end mobile experience for DigiYatra, helping transform six manual identity checks into a seamless digital journey using one-time registration and biometric verification.
          </p>
          <div className="d3" style={{ display:"flex",flexWrap:"wrap",gap:40,paddingTop:24,borderTop:"1px solid #e8e8e8" }}>
            {[{l:"Product",v:"DigiYatra — Govt. of India"},{l:"Platform",v:"Mobile App (iOS & Android)"},{l:"My Role",v:"UI/UX Designer"},{l:"Focus",v:"Flows · Wireframes · UI"},{l:"Users",v:"Indian air passengers — all ages"}].map(m=>(
              <div key={m.l}>
                <p style={{ fontSize:10,fontWeight:600,letterSpacing:".14em",textTransform:"uppercase",color:"#bbb",marginBottom:4 }}>{m.l}</p>
                <p style={{ fontSize:13,fontWeight:600 }}>{m.v}</p>
              </div>
            ))}
          </div>
        </section>

        {/* hero screens */}
        <Sec>
          <div style={{ background:"#111", padding:isMobile?"20px":"32px 28px 28px" }}>
            <p style={{ fontSize:10,fontWeight:600,letterSpacing:".2em",textTransform:"uppercase",color:"#444",textAlign:"center",marginBottom:24 }}>6 checkpoints · 1 registration · zero document checks</p>
            <img src={digiyatradashboardImg} alt="DigiYatra screens" style={{ width:"100%",display:"block" }} />
          </div>
        </Sec>

        {/* ══ PRODUCT HIGHLIGHTS (UX-impact framed) ══ */}
        <Sec>
          <span className="mlabel">Product Highlights</span>
          <div style={{ display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:1,border:"1px solid #e8e8e8",background:"#e8e8e8" }} className="four-col">
            {[
              { num:"3", title:"Passenger Personas", sub:"Frequent • Occasional • First-time" },
              { num:"6", title:"Airport Checkpoints Simplified", sub:"One continuous journey" },
              { num:"1", title:"Unified Registration Experience", sub:"Identity verified once" },
              { num:"A11y", title:"Accessibility First", sub:"Designed for all passenger types" },
            ].map((m,i)=>(
              <div key={i} style={{ padding:"24px 20px",background:"#fff" }}>
                <p style={{ fontSize:"clamp(32px,4vw,48px)",fontWeight:800,letterSpacing:"-0.04em",lineHeight:1,marginBottom:10,color:"#111" }}>{m.num}</p>
                <p style={{ fontSize:13,fontWeight:600,marginBottom:4,color:"#111" }}>{m.title}</p>
                <p style={{ fontSize:12,color:"#aaa" }}>{m.sub}</p>
              </div>
            ))}
          </div>
        </Sec>

        {/* ══ DESIGN PRINCIPLES (NEW) ══ */}
        <Sec>
          <span className="mlabel">Design Principles</span>
          <h2 className="lh" style={{ marginBottom:16 }}>Six principles that guided every screen decision.</h2>
          <p className="bt" style={{ marginBottom:32 }}>
            With a passenger base this diverse, I needed <span className="hl">durable principles</span>, not case-by-case decisions. These six held up across every screen I designed.
          </p>
          <div style={{ display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:1,border:"1px solid #e8e8e8",background:"#e8e8e8" }} className="six-col">
            {[
              { t:"Trust before Convenience", b:"Passengers must trust biometric verification before using it." },
              { t:"One Decision per Screen", b:"Reduce cognitive load during stressful airport journeys." },
              { t:"Invisible Technology", b:"The best interaction is the one passengers barely notice." },
              { t:"Design for the Least Confident User", b:"If first-time elderly passengers succeed, everyone succeeds." },
              { t:"Graceful Failure", b:"Every biometric failure should have a clear recovery path." },
              { t:"Consistency Across Checkpoints", b:"Passengers should never feel they are starting over." },
            ].map((c,i)=>(
              <div key={i} style={{ padding:"22px 20px",background:"#fff" }}>
                <p style={{ fontSize:13,fontWeight:700,marginBottom:8 }}>{c.t}</p>
                <p style={{ fontSize:13,color:"#777",lineHeight:1.65 }}>{c.b}</p>
              </div>
            ))}
          </div>
        </Sec>

        <hr className="div" style={{ marginBottom:80 }} />

        {/* ══ CONTEXT ══ */}
        <Sec>
          <span className="mlabel">Context</span>
          <h2 className="lh" style={{ marginBottom:16 }}>Passengers were checking in their identity six times for one flight.</h2>
          <p className="bt" style={{ marginBottom:36 }}>
            The Government of India introduced DigiYatra to address a system that had become unsustainable at scale:
            long queues, repeated identity verification, a fully paper-based process, growing airport congestion, and mounting passenger frustration.
            At every checkpoint — entry gate, security, boarding — passengers presented the same documents to the same type of verification agent.
            The same person. The same ID. The same boarding pass. <span className="hl">Six times.</span> Not because it's more secure. Because nobody had redesigned the system.
          </p>
          <div style={{ display:"grid",gridTemplateColumns:"1fr 1fr",gap:1,border:"1px solid #e8e8e8",background:"#e8e8e8",marginBottom:32 }} className="two-col">
            {[
              { label:"Repeated identity verification", body:"Passengers present Aadhaar, PAN, or passport + boarding pass at every checkpoint. Same data verified 4–6 times per journey, by different agents with no shared system." },
              { label:"Long queues at every checkpoint", body:"Manual verification creates bottlenecks. During peak hours, security queues alone average 15–20 minutes. The process doesn't scale with passenger volume." },
              { label:"Stress and confusion for first-time flyers", body:"Infrequent flyers — elderly passengers, rural travellers flying for the first time — struggle with unclear signage, unfamiliar systems, and time pressure in an intimidating environment." },
              { label:"No continuity between checkpoints", body:"Each checkpoint operates independently. A passenger cleared at security has to prove their identity again at boarding. There's no system memory — just repeated manual verification." },
            ].map((f,i)=>(
              <div key={i} style={{ padding:"22px 22px",background:"#fff" }}>
                <p style={{ fontSize:13,fontWeight:700,marginBottom:8 }}>{f.label}</p>
                <p style={{ fontSize:13,color:"#777",lineHeight:1.65 }}>{f.body}</p>
              </div>
            ))}
          </div>
          <div className="bq">
            "Users weren't struggling to find content. They were struggling with being treated as strangers at every gate of an airport they'd already entered."
          </div>
        </Sec>

        {/* ══ USERS ══ */}
        <Sec>
          <span className="mlabel">Users</span>
          <h2 className="lh" style={{ marginBottom:16 }}>One app. Every type of Indian air traveller.</h2>
          <p className="bt" style={{ marginBottom:32 }}>
            DigiYatra's user base is unusually wide — from <span className="hl">frequent business flyers to elderly first-time app users</span>.
            The same UI had to work across wildly different levels of digital literacy, language familiarity, and travel experience.
          </p>
          <div style={{ display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:1,border:"1px solid #e8e8e8",background:"#e8e8e8" }} className="three-col">
            {[
              { role:"Frequent Business Flyer", goal:"Reach the gate quickly", freq:"3–5 flights/month", need:"Speed above everything. They know the airport. They want zero friction.", fear:"Any step that slows them down vs the manual queue they already know." },
              { role:"Occasional Leisure Traveller", goal:"Confidence and clarity", freq:"2–4 flights/year", need:"Clarity. They're not sure what DigiYatra is or how it differs from normal check-in.", fear:"Making a mistake that causes them to miss their flight." },
              { role:"First-Time / Elderly Flyer", goal:"Guidance and trust", freq:"1st or 2nd flight ever", need:"Trust and guidance at every step. They need the app to feel safe and simple.", fear:"Technology failing them in a high-stakes, unfamiliar environment." },
            ].map((u,i)=>(
              <div key={i} style={{ background:"#fff",padding:"22px 20px",borderTop:"2px solid #111" }}>
                <p style={{ fontSize:12,fontWeight:800,color:"#111",marginBottom:4 }}>{u.role}</p>
                <p style={{ fontSize:11,color:"#aaa",marginBottom:14 }}>{u.freq}</p>
                <p style={{ fontSize:12,fontWeight:600,color:"#111",marginBottom:4 }}>Core need</p>
                <p style={{ fontSize:12.5,color:"#555",lineHeight:1.5,marginBottom:12 }}>{u.need}</p>
                <p style={{ fontSize:12,fontWeight:600,color:"#111",marginBottom:4 }}>Primary fear</p>
                <p style={{ fontSize:12.5,color:"#777",lineHeight:1.5,marginBottom:14 }}>{u.fear}</p>
                <div style={{ borderTop:"1px solid #f0f0f0", paddingTop:12 }}>
                  <p style={{ fontSize:10,fontWeight:700,letterSpacing:".1em",textTransform:"uppercase",color:"#bbb",marginBottom:3 }}>Primary Goal</p>
                  <p style={{ fontSize:12.5,fontWeight:600,color:"#111" }}>{u.goal}</p>
                </div>
              </div>
            ))}
          </div>
        </Sec>

        <hr className="div" style={{ marginBottom:80 }} />

        {/* ══ IA ══ */}
        <Sec>
          <span className="mlabel">Information Architecture</span>
          <h2 className="lh" style={{ marginBottom:16 }}>Six modules. One principle: the less the passenger does, the better.</h2>
          <p className="bt" style={{ marginBottom:32 }}>
            Every module was designed around <span className="hl">minimising passenger decisions</span>.
            The best DigiYatra interaction is one the passenger doesn't remember having.
          </p>
          <IADiagram />
        </Sec>

        {/* ══ USER JOURNEY ══ */}
        <Sec>
          <span className="mlabel">Journey Flow</span>
          <h2 className="lh" style={{ marginBottom:16 }}>Six checkpoints. One registration. Everything after is invisible.</h2>
          <p className="bt" style={{ marginBottom:24 }}>
            I mapped every checkpoint in the physical airport journey and designed the
            <span className="hl"> digital interaction around each one</span> — including the deliberate decision to make some interactions disappear entirely.
          </p>
          <JourneyLabel />
          <JourneyFlow />
        </Sec>

        <hr className="div" style={{ marginBottom:80 }} />

        {/* ══ KEY DESIGN DECISION ══ */}
        <Sec>
          <span className="mlabel">Key Design Decision</span>
          <h2 className="lh" style={{ marginBottom:16 }}>One screen at the gate — not two.</h2>
          <p className="bt" style={{ marginBottom:32 }}>
            The most consequential gate interaction decision had nothing to do with visual design.
            It was about <span className="hl">how many steps passengers needed to complete at the boarding gate</span>.
            Two screens increased cognitive load — passengers had to track where they were in a sequence under time pressure.
            One confirmation reduced stress by removing the need to track sequence at all.
          </p>

          <div style={{ display:"grid",gridTemplateColumns:"1fr 1fr",gap:1,border:"1px solid #e8e8e8",background:"#e8e8e8",marginBottom:32 }} className="two-col">
            <div style={{ padding:"24px 22px",background:"#fff" }}>
              <p style={{ fontSize:11,fontWeight:700,color:"#bbb",marginBottom:8 }}>✗ Option considered</p>
              <p style={{ fontSize:14,fontWeight:700,color:"#111",marginBottom:10 }}>Two screens — boarding pass then face scan</p>
              <p style={{ fontSize:13,color:"#777",lineHeight:1.65,marginBottom:12 }}>Show the boarding pass QR on screen 1. Then face verification on screen 2. Mirrors how physical documents work today.</p>
              <div style={{ paddingTop:12,borderTop:"1px solid #f0f0f0" }}>
                <p style={{ fontSize:12.5,color:"#ef4444",lineHeight:1.6 }}>↳ Under time pressure, passengers frequently closed the app after showing the boarding pass — treating it as the final step. Gate staff had to intervene, creating the exact queues DigiYatra was built to eliminate.</p>
              </div>
            </div>
            <div style={{ padding:"24px 22px",background:"#111" }}>
              <p style={{ fontSize:11,fontWeight:700,color:"#555",marginBottom:8 }}>✓ Decision made</p>
              <p style={{ fontSize:14,fontWeight:700,color:"#fff",marginBottom:10 }}>Unified single-scan experience</p>
              <p style={{ fontSize:13,color:"#888",lineHeight:1.65,marginBottom:12 }}>Boarding pass QR and face recognition pre-linked at registration. The gate scan resolves identity and boarding in one action — nothing to switch between, nothing to forget.</p>
              <div style={{ paddingTop:12,borderTop:"1px solid #222" }}>
                <p style={{ fontSize:12.5,color:"#22c55e",lineHeight:1.6 }}>↳ Gate interaction reduced to a single moment. Passengers don't manage two documents — the system already knows who they are from registration.</p>
              </div>
            </div>
          </div>

          <div style={{ display:"grid",gridTemplateColumns:"1fr 1fr",gap:1,border:"1px solid #e8e8e8",background:"#e8e8e8",marginBottom:24 }} className="two-col">
            <div style={{ padding:"24px 24px",background:"#fff",borderTop:"3px solid #111" }}>
              <p style={{ fontSize:11,fontWeight:700,letterSpacing:".12em",textTransform:"uppercase",color:"#aaa",marginBottom:12 }}>The insight that drove this</p>
              <p style={{ fontSize:15,fontWeight:700,color:"#111",lineHeight:1.4,marginBottom:12 }}>The two-screen model assumed users understood the system's internal flow. The unified model assumed they didn't.</p>
              <p style={{ fontSize:14,color:"#555",lineHeight:1.75 }}>
                Research showed passengers treated showing the boarding pass as the <em>end</em> of the gate interaction — not the middle of one.
                <span className="hl"> Designing for how users actually behave under pressure</span>, not how they would behave in ideal conditions, was the shift that made this work.
              </p>
            </div>
            <div style={{ padding:"24px 24px",background:"#fff",borderTop:"3px solid #111" }}>
              <p style={{ fontSize:11,fontWeight:700,letterSpacing:".12em",textTransform:"uppercase",color:"#aaa",marginBottom:16 }}>Tradeoff</p>
              <div style={{ display:"flex",flexDirection:"column",gap:14 }}>
                {[
                  { label:"What I gained", col:"#22c55e", body:"Zero cognitive load at the gate. Users never think about sequencing — the face scan at registration does the heavy lifting once, and every airport interaction after that becomes genuinely invisible." },
                  { label:"What I gave up", col:"#f59e0b", body:"Transparency — some users felt uncertain about 'what just happened' at the gate since there was less to do. I addressed this with clear confirmation push notifications and a brief explainer during onboarding — not at the gate itself." },
                ].map((t,i)=>(
                  <div key={i} style={{ paddingBottom:12,borderBottom:i<1?"1px solid #f0f0f0":"none" }}>
                    <p style={{ fontSize:11,fontWeight:700,color:t.col,letterSpacing:".1em",textTransform:"uppercase",marginBottom:6 }}>{t.label}</p>
                    <p style={{ fontSize:12.5,color:"#666",lineHeight:1.6 }}>{t.body}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div style={{ padding:"20px 24px",borderLeft:"3px solid #111",background:"#fff",border:"1px solid #e8e8e8",borderLeft:"3px solid #111" }}>
            <p className="bq" style={{ fontSize:14 }}>The biggest usability failures often look fine in a flow diagram. Two screens, two steps — logical on paper. But under real airport conditions — noise, time pressure, unfamiliar tech — that second tap is the one that breaks the experience.</p>
          </div>
        </Sec>

        {/* ══ DESIGN ALTERNATIVES CONSIDERED (NEW) ══ */}
        <Sec>
          <span className="mlabel">Design Alternatives Considered</span>
          <h2 className="lh" style={{ marginBottom:16 }}>Why facial recognition — not QR codes or OTP.</h2>
          <p className="bt" style={{ marginBottom:32 }}>
            Before settling on facial recognition as the core verification method, I evaluated two simpler alternatives.
            Both failed the <span className="hl">"does this remove friction or just relocate it?"</span> test.
          </p>
          <div style={{ display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:1,border:"1px solid #e8e8e8",background:"#e8e8e8" }} className="three-col">
            <div style={{ padding:"22px 20px",background:"#fff" }}>
              <p style={{ fontSize:11,fontWeight:700,color:"#bbb",marginBottom:8 }}>✗ Rejected</p>
              <p style={{ fontSize:14,fontWeight:700,color:"#111",marginBottom:10 }}>QR Code Only</p>
              <p style={{ fontSize:13,color:"#777",lineHeight:1.65 }}>Still requires passengers to manage documents — opening an app, finding a screen, presenting a code. The friction just moves from paper to phone.</p>
            </div>
            <div style={{ padding:"22px 20px",background:"#fff" }}>
              <p style={{ fontSize:11,fontWeight:700,color:"#bbb",marginBottom:8 }}>✗ Rejected</p>
              <p style={{ fontSize:14,fontWeight:700,color:"#111",marginBottom:10 }}>OTP Verification</p>
              <p style={{ fontSize:13,color:"#777",lineHeight:1.65 }}>Too slow for airport flow. Waiting for an SMS at a security checkpoint with people queued behind you creates a worse experience than the manual process it replaces.</p>
            </div>
            <div style={{ padding:"22px 20px",background:"#111" }}>
              <p style={{ fontSize:11,fontWeight:700,color:"#555",marginBottom:8 }}>✓ Chosen</p>
              <p style={{ fontSize:14,fontWeight:700,color:"#fff",marginBottom:10 }}>Face Recognition</p>
              <p style={{ fontSize:13,color:"#888",lineHeight:1.65 }}>Fast, contactless, hands-free, and scalable. No document to find, no code to wait for — the passenger simply walks through.</p>
            </div>
          </div>
        </Sec>

        {/* ══ DESIGN DECISIONS WITH SCREENS ══ */}
        <Sec>
          <span className="mlabel">Design Decisions — Key Screens</span>
          <h2 className="lh" style={{ marginBottom:16 }}>Every screen decision was tested against one question: does this work in an airport?</h2>
          <p className="bt" style={{ marginBottom:32 }}>
            Airports are loud, time-pressured, and cognitively demanding. An interface that requires reading fails in the field.
            For every screen below, I worked through the problem, the decision, and the reason — not just the visual outcome.
          </p>
          <ScreenFull src={digiyatradashboardImg} alt="DigiYatra UI screens" bg="#f0f4ff"
            annotations={[
              { label:"Consent first, capture second", body:"Problem: passengers won't trust an unfamiliar biometric ask. Reason: trust must be established before asking for a face scan — explicit, plain-language consent before any camera access; data policy visible without scrolling." },
              { label:"One action per screen, always", body:"Problem: multi-step forms cause drop-off under stress. Reason: no multi-step forms, no side-by-side choices — one instruction, one button, one outcome, reducing decision fatigue for elderly and first-time flyers." },
              { label:"Large CTAs designed for time pressure", body:"Problem: small targets fail under time pressure. Reason: full-width, minimum 48px height, high-contrast — at a busy gate with 2 minutes to board, a passenger cannot be squinting at a small button." },
              { label:"Friendly, specific error messages", body:"Problem: generic errors cause abandonment. Reason: 'Move to better light' not 'Face not detected' — specific guidance prevents abandonment at the most critical moments in the flow." },
              { label:"Confirmation states are first-class screens", body:"Problem: passengers need certainty, not a notification. Reason: boarding confirmed, security cleared, entry approved — each is a full screen, not a dismissable toast." },
              { label:"Icon-supported labels throughout", body:"Problem: India spans 22 languages and varying literacy. Reason: every text label has an icon companion, designed for users across language backgrounds and literacy levels." },
            ]}
          />
        </Sec>

        {/* ══ DESIGNING FOR DIVERSE PASSENGERS ══ */}
        <Sec>
          <span className="mlabel">Designing for Diverse Passengers</span>
          <h2 className="lh" style={{ marginBottom:16 }}>Reducing cognitive load for every level of digital confidence.</h2>
         <p className="bt" style={{ marginBottom:32 }}>
  DigiYatra is used by everyone—from frequent business travellers to elderly first-time flyers—all under the same time pressure.
  Instead of assuming every passenger was comfortable with technology, I focused on <span className="hl">making every interaction feel simple, predictable, and trustworthy</span>, so people could move through the airport with confidence.
</p>
          <div style={{ display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:1,border:"1px solid #e8e8e8",background:"#e8e8e8" }} className="three-col">
            {[
              { t:"Large touch targets", b:"Primary actions were designed to be easy to tap during stressful airport situations, especially for elderly passengers." },
              { t:"One action per screen", b:"Every screen focused on a single task, reducing confusion and helping passengers move confidently through the journey." },
              { t:"Plain language", b:"Instructions avoided technical terminology and used simple, human-friendly language that passengers could quickly understand." },
              { t:"Helpful error recovery", b:"Instead of generic failure messages, the interface explained what went wrong and guided passengers toward the next step." },
              { t:"Manual verification fallback", b:"When facial recognition could not complete successfully, passengers could continue through the existing airport verification process instead of being blocked." },
              { t:"Designed for confidence", b:"Every interaction was designed to reduce uncertainty and help passengers feel confident while using unfamiliar technology." },
            ].map((c,i)=>(
              <div key={i} style={{ padding:"22px 20px",background:"#fff" }}>
                <p style={{ fontSize:13,fontWeight:700,marginBottom:8 }}>{c.t}</p>
                <p style={{ fontSize:13,color:"#777",lineHeight:1.65 }}>{c.b}</p>
              </div>
            ))}
          </div>
        </Sec>

        {/* ══ PRIVACY BY DESIGN (NEW) ══ */}
        <Sec>
          <span className="mlabel">Privacy by Design</span>
          <h2 className="lh" style={{ marginBottom:16 }}>Biometric trust requires biometric transparency.</h2>
          <p className="bt" style={{ marginBottom:32 }}>
            A facial recognition product can't earn passenger trust without being explicit about <span className="hl">what data is collected, where it lives, and how it's verified</span>.
          </p>
          <div style={{ display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:1,border:"1px solid #e8e8e8",background:"#e8e8e8" }} className="three-col">
            {[
              { t:"Explicit biometric consent", b:"No face data captured without an active, informed opt-in at registration." },
              { t:"Plain-language permissions", b:"Permission requests use everyday language, not legal or technical phrasing." },
              { t:"DigiLocker integration", b:"Identity documents verified through India's existing trusted government infrastructure." },
              { t:"No biometric data stored locally", b:"Face data isn't retained on-device after verification completes." },
              { t:"Secure token-based verification", b:"Checkpoints verify against an encrypted token, not raw biometric data." },
              { t:"Manual verification fallback", b:"Passengers who opt out, or whose scan fails, always have a human-assisted path." },
            ].map((c,i)=>(
              <div key={i} style={{ padding:"22px 20px",background:"#fff" }}>
                <p style={{ fontSize:13,fontWeight:700,marginBottom:8 }}>{c.t}</p>
                <p style={{ fontSize:13,color:"#777",lineHeight:1.65 }}>{c.b}</p>
              </div>
            ))}
          </div>
        </Sec>

        <hr className="div" style={{ marginBottom:80 }} />

        {/* ══ CONSTRAINTS & TRADEOFFS ══ */}
        <Sec>
          <span className="mlabel">Constraints & Tradeoffs</span>
          <h2 className="lh" style={{ marginBottom:16 }}>Designing for everyone means no one is the edge case.</h2>
          <p className="bt" style={{ marginBottom:36 }}>
            DigiYatra has the most diverse user base of any project I've worked on.
            A 28-year-old tech-fluent business flyer and a <span className="hl">67-year-old first-time flyer from a small town</span> will use the same app in the same airport under the same time pressure.
            Every decision balanced security, government regulations, passenger trust, and airport operational constraints — designing for both wasn't optional, it was the brief.
          </p>

          {/* main constraint */}
          <div style={{ display:"grid",gridTemplateColumns:"1fr 1fr",gap:1,border:"1px solid #e8e8e8",background:"#e8e8e8",marginBottom:1 }} className="two-col">
            <div style={{ padding:"28px 26px",background:"#fff",borderTop:"3px solid #111" }}>
              <p style={{ fontSize:11,fontWeight:700,letterSpacing:".12em",textTransform:"uppercase",color:"#aaa",marginBottom:12 }}>Primary constraint</p>
              <p style={{ fontSize:24,fontWeight:800,color:"#111",lineHeight:1.25,marginBottom:14,letterSpacing:"-0.02em" }}>India's passenger base spans 22 languages, wildly different digital literacy levels, and ages from 18 to 75+.</p>
              <p style={{ fontSize:14,color:"#666",lineHeight:1.75 }}>
                The same screen that a business flyer glances at in 1 second must also guide a 65-year-old woman flying for the first time, in a language that may not be her first, in an airport she's never been to. There is no "average user" here.
              </p>
            </div>
            <div style={{ background:"#fff",padding:"28px 26px",borderTop:"3px solid #111" }}>
              <p style={{ fontSize:11,fontWeight:700,letterSpacing:".12em",textTransform:"uppercase",color:"#aaa",marginBottom:16 }}>Design responses</p>
              <div style={{ display:"flex",flexDirection:"column",gap:14 }}>
                {[
                  { label:"Designed for the lowest-confidence user", body:"Large type, high contrast, icon-supported labels, minimal text. If the first-time elderly user can navigate it, the business flyer certainly can." },
                  { label:"No jargon, no technical language", body:"'Scan your face' not 'Biometric authentication.' 'You're cleared' not 'Verification successful.' Language borrowed from human-to-human airport interactions." },
                  { label:"Error recovery for every failure state", body:"Face scan fails because of poor lighting → specific guidance. GPS wrong → explain and offer manual fallback. Every failure has a human-readable next step." },
                ].map((c,i)=>(
                  <div key={i} style={{ paddingBottom:12,borderBottom:i<2?"1px solid #f0f0f0":"none" }}>
                    <p style={{ fontSize:13,fontWeight:700,color:"#111",marginBottom:4 }}>{c.label}</p>
                    <p style={{ fontSize:12.5,color:"#666",lineHeight:1.6 }}>{c.body}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Tradeoffs table */}
          <div style={{ border:"1px solid #e8e8e8",background:"#e8e8e8",display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:1 }} className="three-col">
            <div style={{ padding:"14px 20px",background:"#fafafa" }}>
              <p style={{ fontSize:10,fontWeight:700,color:"#aaa",letterSpacing:".12em",textTransform:"uppercase" }}>Tradeoff</p>
            </div>
            <div style={{ padding:"14px 20px",background:"#fafafa" }}>
              <p style={{ fontSize:10,fontWeight:700,color:"#aaa",letterSpacing:".12em",textTransform:"uppercase" }}>What I gave up</p>
            </div>
            <div style={{ padding:"14px 20px",background:"#fafafa" }}>
              <p style={{ fontSize:10,fontWeight:700,color:"#aaa",letterSpacing:".12em",textTransform:"uppercase" }}>Why it was worth it</p>
            </div>
            {[
              { t:"No primary user research access — designed from product requirements", g:"Design decisions weren't validated against observed user behaviour before delivery.", w:"Airport-context domain expertise + design principles for high-stress environments + stakeholder review filled the gap. Every screen decision has a documented rationale." },
              { t:"One screen, one action — strict information density limit", g:"Power users (frequent flyers) get less information per screen than they're capable of processing.", w:"The lower bound of the user base — first-time elderly flyers under time pressure — defines the ceiling, not the floor. Speed of recognition beats density of information." },
              { t:"Unified gate scan — boarding pass and face linked at registration", g:"Some passengers feel uncertain about 'what just happened' since they did less at the gate.", w:"Confirmation push notification + onboarding explainer resolves the uncertainty. The trade: momentary confusion for permanent friction elimination." },
              { t:"Friendly error language — specific guidance over technical accuracy", g:"Some edge cases get simplified explanations that don't fully describe what's technically wrong.", w:"A first-time 65-year-old user at a boarding gate needs to know 'move to better light' — not that the biometric confidence threshold wasn't met." },
              { t:"No navigation bar during critical flow steps", g:"Users cannot jump between sections mid-flow — they must complete or consciously exit.", w:"Reduces context-switching at high-stress moments. A passenger mid-security-check doesn't need to navigate to Settings. Linear completion is the right UX here." },
            ].map((row,i)=>(
              <>
                <div key={`a${i}`} style={{ padding:"18px 20px",background:"#fff" }}><p style={{ fontSize:13,fontWeight:600,color:"#333",lineHeight:1.5 }}>{row.t}</p></div>
                <div key={`b${i}`} style={{ padding:"18px 20px",background:"#fff" }}><p style={{ fontSize:13,color:"#888",lineHeight:1.6 }}>{row.g}</p></div>
                <div key={`c${i}`} style={{ padding:"18px 20px",background:"#fff" }}><p style={{ fontSize:13,color:"#555",lineHeight:1.6 }}>{row.w}</p></div>
              </>
            ))}
          </div>
        </Sec>

        <hr className="div" style={{ marginBottom:80 }} />

        {/* ══ FUTURE OPPORTUNITIES (NEW) ══ */}
        <Sec>
          <span className="mlabel">Future Opportunities</span>
          <h2 className="lh" style={{ marginBottom:16 }}>If I redesigned DigiYatra today.</h2>
          <p className="bt" style={{ marginBottom:32 }}>
            With current AI capabilities, several directions could push the experience further — <span className="hl">without compromising the trust and simplicity</span> the current design earned.
          </p>
          <div style={{ display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:1,border:"1px solid #e8e8e8",background:"#e8e8e8" }} className="three-col">
            {[
              { t:"AI-powered onboarding assistant", b:"Conversational guidance through registration for first-time, low-literacy users." },
              { t:"Voice-guided accessibility", b:"Spoken instructions at each checkpoint for visually impaired or low-literacy passengers." },
              { t:"Predictive boarding notifications", b:"Proactive alerts based on gate distance and security wait times, not just flight time." },
              { t:"Offline verification support", b:"Fallback verification for low-connectivity zones within the airport." },
              { t:"Personalized travel assistance", b:"Tailored guidance based on travel frequency and demonstrated comfort with the app." },
              { t:"Accessibility preferences", b:"Persistent profile settings — text size, language, contrast — carried across every checkpoint." },
            ].map((c,i)=>(
              <div key={i} style={{ padding:"22px 20px",background:"#fff" }}>
                <p style={{ fontSize:13,fontWeight:700,marginBottom:8 }}>{c.t}</p>
                <p style={{ fontSize:13,color:"#777",lineHeight:1.65 }}>{c.b}</p>
              </div>
            ))}
          </div>
        </Sec>

        <hr className="div" style={{ marginBottom:80 }} />

        {/* ══ LEARNINGS ══ */}
        <Sec>
          <span className="mlabel">Retrospective</span>
          <h2 className="lh" style={{ marginBottom:32 }}>What this project taught me.</h2>
          {[
            { t:"Simplifying complexity is a design skill — not a shortcut", b:"The hardest part wasn't making the app look clean. It was deciding what to completely remove and still have the experience feel complete, safe, and trustworthy." },
            { t:"Real-world environments demand unambiguous UI", b:"Airports are loud, rushed, and stressful. An interface that requires reading fails in the field. Every screen needed to communicate its purpose in under two seconds — with or without context." },
            { t:"Designing for stress states, not steady states", b:"The two-screen gate interaction looked fine in a flow diagram. Under real airport conditions — noise, time pressure, unfamiliar technology — that second tap broke the experience. Steady-state usability is necessary but not sufficient." },
            { t:"Error states are core to the experience, not afterthoughts", b:"In biometric flows, failure is common and expected. Face scan fails because of glasses, lighting, angle. Designing the error state as carefully as the success state separates a robust production-ready design from a prototype." },
            { t:"The best digital experiences are often invisible", b:"This project reinforced that the best digital experiences are often invisible. When technology disappears into the background, users can focus on their journey rather than the interface." },
          ].map((item,i,arr)=>(
            <div key={i} style={{ display:"flex",gap:24,padding:"24px 0",borderBottom:i<arr.length-1?"1px solid #e8e8e8":"none",alignItems:"flex-start" }}>
              <p style={{ fontSize:13,fontWeight:700,color:"#ccc",flexShrink:0,minWidth:28 }}>0{i+1}</p>
              <div>
                <p style={{ fontSize:15,fontWeight:700,color:"#111",marginBottom:6 }}>{item.t}</p>
                <p style={{ fontSize:14,color:"#666",lineHeight:1.8 }}>{item.b}</p>
              </div>
            </div>
          ))}
        </Sec>

        {/* ── NEXT ── */}
        <div onClick={()=>navigate("/")}
          style={{ padding:"32px 32px",border:"1px solid #e8e8e8",background:"#fff",cursor:"pointer",transition:"border-color .2s" }}
          onMouseEnter={e=>{e.currentTarget.style.borderColor="#111"}}
          onMouseLeave={e=>{e.currentTarget.style.borderColor="#e8e8e8"}}>
          <p style={{ fontSize:10,fontWeight:600,letterSpacing:".16em",textTransform:"uppercase",color:"#aaa",marginBottom:8 }}>Explore more</p>
          <h3 style={{ fontSize:20,fontWeight:800,letterSpacing:"-0.02em" }}>Back to all work →</h3>
          <p style={{ fontSize:13,color:"#aaa",marginTop:6 }}>IndustrialGas · CloudEvolve · DigiYatra</p>
        </div>

      </main>
    </div>
  );
}